import Input from '../../../Input/Input';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { object } from 'yup';
import { stringScheme } from 'src/utils/validation-schemes';
import { useParams } from 'react-router-dom';
import { useGetProjectByIdQuery } from 'src/services';
import type { SelectedIntegration } from 'src/store/slices/integrationSlice';
import type { IntegrationSubmitHandler } from 'src/components/Integrations/integrationFormTypes';

export const IntegrationFormFreshdeskChat = ({
  integration,
  onSubmit,
}: {
  integration?: SelectedIntegration;
  onSubmit?: IntegrationSubmitHandler;
}) => {
  const { id } = useParams();
  const { data: currentProject } = useGetProjectByIdQuery({ id: id });
  const { handleSubmit, control } = useForm({
    defaultValues: {
      chat_url: integration?.integration_data?.chat_url || '',
      api_key: '',
    },
    resolver: yupResolver(
      object({
        chat_url: stringScheme({ required: true }).label('Chat URL'),
        api_key: stringScheme({ required: true }).label('API Key'),
      }),
    ),
  });

  const submit = (data: { chat_url: string; api_key: string }) => {
    onSubmit({
      ...integration,
      integration_data: {
        ...integration.integration_data,
        name: currentProject.name,
        chat_url: data.chat_url,
        api_key: data.api_key,
      },
    });
  };

  return (
    <form id="integration-form" onSubmit={handleSubmit(submit)} className={'flex flex-col gap-2.5'}>
      <div>
        <Controller
          control={control}
          name="chat_url"
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <Input
              type={'text'}
              label={'Chat URL'}
              placeholder={'https://chat.openai.com/c/12345678-abcd-efgh-ijkl-9876543210mn'}
              invalidMessage={error?.message}
              value={value}
              isValid={!error?.message}
              onChange={onChange}
              infoTooltip={{
                side: 'right',
                description: (
                  <>
                    Freshchat Admin Settings → Marketplace <br /> & Integrations → API Settings →
                    Chat URL
                  </>
                ),
              }}
            />
          )}
        />
      </div>
      <div>
        <Controller
          control={control}
          name="api_key"
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <Input
              type={'text'}
              label={'API Key'}
              placeholder={'sk-4r4nD0mL3tt3r5AndNum83r5XXXXXXXXXXXXXXX'}
              invalidMessage={error?.message}
              value={value}
              isValid={!error?.message}
              onChange={onChange}
              infoTooltip={{
                side: 'right',
                description: (
                  <>
                    Freshchat Admin Settings → Marketplace
                    <br /> & Integrations → API Settings → Generate Token
                  </>
                ),
              }}
            />
          )}
        />
      </div>
    </form>
  );
};
